import { useTrainingSteps } from '../../hooks/Training';
import BCard from '../ui/generic/BCard';
import { IconArrowRight, IconCheck, IconX } from '@tabler/icons-react';
import { BBadge, BButton } from '../ui/generic';
import { useNavigate } from 'react-router';
import useUser from '../../hooks/User';
import { getAgeFromDateString } from '../../utils';
import { variant } from '../ui/generic/utils';

const ContractCfa = ({ training }) => {
  const { data: user, isSuccess: user_isSuccess } = useUser();
  const navigate = useNavigate();

  const status = training?.contract?.status;
  const { data: steps, isSuccess } = useTrainingSteps(training.id);
  if (!isSuccess || !user_isSuccess) return;
  const getCurrentStepName = () => {
    switch (steps.length) {
      case 0:
      case 1:
        return 'informations';
      case 2:
        return 'documents';
      case 3:
        return 'signature';
    }
  };
  const isMineur = getAgeFromDateString(user.birth_day) < 18;
  return (
    <BCard>
      <BCard.Header>
        <div className="flex flex-col gap-1">
          <p className={'text-xs font-medium text-slate-700'}>Dossier N°{training.id}</p>
          <h1 className={'text-lg leading-none font-semibold'}>{training.category} - demande d'alternance</h1>
        </div>
        {status === 'Stagiaire CFA' && (
          <BBadge size={'large'} rounded={variant.rounded.square} color={variant.color.green}>
            Stagiaire de la formation
          </BBadge>
        )}
      </BCard.Header>
      <BCard.Body>

        <h2 className={'text-slate-700'}>Avancement de votre dossier</h2>
        <div className={'flex flex-col gap-2'}>
          <Body label={'Étape 1 : Informations'} isStepCompleted={steps.includes('infosClient')} />
          <Body label={'Étape 2 : Éligibilité'} isStepCompleted={steps.includes('eligibilite')} />
          <Body label={'Étape 3 : Documents'} isStepCompleted={steps.includes('documents')} />
          {!isMineur && <Body label={'Étape 4 : Signature'} isStepCompleted={steps.includes('signature')} />}{' '}
        </div>
        <div className={'flex w-full justify-end'}>
          {status !== 'Stagiaire CFA' && (
            <div>
              <BButton
                isDisabled={steps.length === 4 || (steps.length === 3 && isMineur)}
                onClick={() => navigate(`/inscription/${getCurrentStepName()}/${training.id}`)}
                icon={steps.length === 4 || (steps.length === 3 && isMineur) ? IconCheck : IconArrowRight}
                iconRight
                label={
                  steps.length === 4 || (steps.length === 3 && isMineur)
                    ? 'En cours de vérification'
                    : 'Je démarre mon dossier'
                }
                size={'lg'}
              />
            </div>
          )}
        </div>
      </BCard.Body>
    </BCard>
  );
};
const Body = ({ isStepCompleted = false, label }) => (
  <div className={'no-scrollbar flex items-center justify-between overflow-x-scroll text-sm leading-tight font-normal'}>
    <p className={'text-nowrap text-slate-400'}>{label}</p>
    {isStepCompleted ? <IconCheck className={'text-green-600'} /> : <IconX className={'text-red-500'} />}{' '}
  </div>
);

export default ContractCfa;
